import React from "react";
import PageHeader from "../../PageHeader";
import AddSectionForm from "./AddSectionForm";
import { ReactComponent as SectionIcon } from "../../../images/sectionimage/Section.svg";
import { ReactComponent as BackIcon } from "../../../images/pageheadingicon/backicon.svg";
import useStyles from "../../../../styles";

function AddSection() {
  const classes = useStyles();
  const Heading = [
    {
      id: 1,
      pageicon: <SectionIcon />,
      mainheading: "Add Section",
      // subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      addbtntext: "Back",
      addbtnicon: <BackIcon />,
      addbtnstyle: "transparentbtn",
      path: "/admin/section",
    },
  ];
  return (
    <div className={`${classes.p2} ${classes.pb0}`}>
      <PageHeader Heading={Heading} />
      <AddSectionForm />
    </div>
  );
}
export default AddSection;
